import { z } from "zod";
const dataUriSchema = z
    .string()
    .max(34_000_000)
    .regex(/^data:image\/(png|jpeg|webp);base64,/);
export const aiExampleRefSchema = z.union([
    z.object({ mediaId: z.number().int() }).strict(),
    z.object({ generatedImageId: z.number().int() }).strict(),
    z.object({ dataUri: dataUriSchema }).strict(),
]);
export const aiGenerateRequestSchema = z
    .object({
    mode: z.enum(["generate", "edit"]),
    modelId: z.string().min(1).max(200),
    prompt: z.string().min(1).max(32768),
    negativePrompt: z.string().max(4000).optional(),
    aspectRatio: z.string().optional(),
    resolution: z.string().optional(),
    quality: z.string().optional(),
    variants: z.number().int().min(1).max(4).default(1),
    seed: z.number().int().optional(),
    examples: z.array(aiExampleRefSchema).max(10).default([]),
})
    .superRefine((v, ctx) => {
    if (v.mode === "edit") {
        if (v.examples.length < 1)
            ctx.addIssue({ code: "custom", path: ["examples"], message: "edit mode requires at least one example" });
        if (v.variants !== 1)
            ctx.addIssue({ code: "custom", path: ["variants"], message: "edit mode supports a single variant" });
    }
    else if (v.examples.length !== 0) {
        ctx.addIssue({ code: "custom", path: ["examples"], message: "generate mode takes no examples" });
    }
});
